export { default as TadaTopLeft } from './TadaTopLeft'
export { default as TadaTopLeftTwo } from './TadaTopLeftTwo'
export { default as TadaBottomLeft } from './TadaBottomLeft'
export { default as TadaTopRight } from './TadaTopRight'
